export function getExtension(filename: any) {
    var parts = filename.split(".");
    return parts[parts.length - 1];
}

export function isPdf(filename: any) {
    var ext = getExtension(filename);
    switch (ext.toLowerCase()) {
        case "pdf":
        return true;
    }
    return false;
}